import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadProgressComponent } from 'src/app/shared/components/upload-progress/upload-progress.component';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { ImageCropperComponent } from 'src/app/shared/components/image-cropper/image-cropper.component';

@Component({
  selector: 'project-brochure',
  templateUrl: './brochure.component.html',
  styleUrls: ['./brochure.component.css']
})
export class BrochureComponent implements OnInit {

  @Output() showNextPage: EventEmitter<number> = new EventEmitter();
  brochureImages: Array<string> = [
    '',
    '',
    '',
    '',
    '',
    ''
  ];
  selectedProperty: any;

  constructor(
    private modalService: NgbModal,
    private rsbService: RsbService,
    private lookupModel: RsbLookupModel,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.selectedProperty = this.lookupModel.getVendorProperty() ? this.lookupModel.getVendorProperty() : null;
    if(this.selectedProperty && this.selectedProperty.brochureImages) {
      this.brochureImages = this.selectedProperty.brochureImages;
    }
  }

  uploadAws(event: any, index: number): void {
    const mdlRef = this.modalService.open(ImageCropperComponent, { windowClass: 'signInForm'});
    mdlRef.componentInstance.imageChangedEvent = event;
    mdlRef.result.then((cropResp: {image: any, markDefault: boolean}) => {
      if(cropResp && cropResp.image) {
        const modalRef = this.modalService.open(UploadProgressComponent, { windowClass: 'signInForm' });
        modalRef.componentInstance.file = cropResp.image;
        modalRef.result.then((path: any) => {
          if (path?.image) {
            if(this.brochureImages[index]) {
              this.brochureImages[index] = path.image;
            } else {
              const imageList = this.brochureImages.filter(item => item !== '');
           
                imageList.push(path?.image);
              
              if(imageList.length < 6) {
                const length = 6 - imageList.length;
                for(var i=0 ; i < length; i++) {
                  imageList.push('');
                }
              }
              this.brochureImages = [...imageList];
            }
            this.cdr.detectChanges();
          }
        });
      }
    });
  }

  back(): void {
    this.showNextPage.emit(4)
  }

  submit(): void {
    let property = this.lookupModel.getVendorProperty();
    property.brochure = this.brochureImages;
    this.lookupModel.setVendorProperty(property);
    this.showNextPage.emit(6);
  }
    
  

}